import { mapProps } from 'recompose'

export default mapProps(({ history, location, match, children }) => {
  return {
    ...match.params,
    ...location.query,
    children,
  }
})
